import type { ModuleName } from "@bt/domain";
import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "./trpc";

/**
 * Whether a module is active in this garage (ADR 0017): its menu entries, screens and sections
 * show only then. False while the garage's access is loading.
 */
export function useModule(name: ModuleName): boolean {
  const trpc = useTRPC();
  const { data } = useQuery(trpc.garages.access.queryOptions());
  return data?.activeModules.includes(name) ?? false;
}
